import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getOngoingDeals = createAsyncThunk(
  "orders/getOngoingDeals",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getOrderDeals?orgId=${payload.orgId}&type=${payload.type}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    ordersData: {},
    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getOngoingDeals.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getOngoingDeals.fulfilled, (state, action) => {
      state.loading = false;
      state.ordersData = action.payload;
      state.error = null;
    });
    builder.addCase(getOngoingDeals.rejected, (state, action) => {
      state.loading = false;
      state.ordersData = {};
      state.error = action.payload;
    });
  },
  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const { } = ordersSlice.actions;

export default ordersSlice.reducer;
